import { ComponentType, HTMLAttributes, useCallback, useState } from 'react';

import { ImageIcon } from '@radix-ui/react-icons';
import { type Editor } from '@tiptap/react';

import { Button } from '../../../primitives/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';
import { cn } from '../../../utils/cn';

export type MediaPickerComponent = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (params: { url: string }) => void;
};

interface ButtonImageProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
  mediaPicker?: ComponentType<MediaPickerComponent>;
}

export function ButtonImage({ className, editor, mediaPicker }: ButtonImageProps) {
  const MediaPicker = mediaPicker;
  const [open, setOpen] = useState(false);

  const addImage = useCallback(() => {
    const url = window.prompt('URL');

    if (url === null) {
      return;
    }

    if (url) {
      editor.chain().focus().setImage({ src: url, alt: 'imagen' }).run();
    }
  }, [editor]);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <Button
              aria-label="Agregar imagen"
              className={cn('text-success', className)}
              disabled={!editor.isEditable}
              size="icon"
              variant="ghost"
              onClick={() => {
                if (mediaPicker) {
                  setOpen(true);
                } else {
                  addImage();
                }
              }}
            >
              <ImageIcon className="size-4" />
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p className="flex flex-col">Agregar imagen</p>
        </TooltipContent>
      </Tooltip>
      {MediaPicker ? (
        <MediaPicker
          open={open}
          onOpenChange={setOpen}
          onSubmit={(params) => {
            if (params?.url) {
              editor.chain().focus().setImage({ src: params.url, alt: 'imagen' }).run();

              setOpen(false);
            }
          }}
        />
      ) : null}
    </>
  );
}
